// extracted by mini-css-extract-plugin
module.exports = {"figure":"CrowdersSmallFigure--figure--20SN1","background":"CrowdersSmallFigure--background--3e5Gl"};